import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const AcademyListPage = () =>
  import('@modules/academy/components/academy-list-page.vue');
const AcademyFormPage = () =>
  import('@modules/academy/components/academy-form-page.vue');
const AcademyViewPage = () =>
  import('@modules/academy/components/academy-view-page.vue');
const AcademyImporterPage = () =>
  import('@modules/academy/components/academy-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'academy',
        path: '/academy',
        component: AcademyListPage,
        meta: {
          auth: true,
          permission: Permissions.values.academyView,
        },
      },
      {
        name: 'academyNew',
        path: '/academy/new',
        component: AcademyFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.academyCreate,
        },
      },
      {
        name: 'academyImporter',
        path: '/academy/import',
        component: AcademyImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.academyImport,
        },
      },
      {
        name: 'academyEdit',
        path: '/academy/:id/edit',
        component: AcademyFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.academyEdit,
        },
        props: true,
      },
      {
        name: 'academyView',
        path: '/academy/:id',
        component: AcademyViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.academyView,
        },
        props: true,
      },
    ],
  },
];
